module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="suggestions__intro suggestions__intro--test detail-hidden">\n    <span>\n        Before we get to review, we found ' +
__e( count ) +
' job';
 if (count > 1 ) { ;
__p += 's';
 } ;
__p += '\n        we think you\'d also be a good candidate for.\n    </span>\n    <strong>Add them to your application?</strong>\n    <em class="mobile-only">(Tap to select/deselect)</em>\n</div>\n\n<ul class="suggestions-row__container checkbox-list checkbox-list-left detail-hidden">\n    ';
 suggestions.forEach(function(s) { ;
__p += '\n        <li class="suggestion-row suggestion-row--selected">\n            <div class="suggestion-row__checkbox">\n                <input\n                    checked\n                    type="checkbox"\n                    id="position-' +
__e( s.id ) +
'"\n                    name="positions"\n                    value="' +
__e( s.id ) +
'"\n                />\n                <label for="position-' +
__e( s.id ) +
'"></label>\n            </div>\n\n            <div class="suggestion-row__title-container">\n                <div class="suggestion-row__title">\n                    <a\n                        href="' +
__e( s.link ) +
'"\n                        class="js-job-detail js-job-data"\n                        data-id="position-detail-' +
__e( s.id ) +
'"\n                        data-url="' +
__e( s.link ) +
'"\n                        data-hide-footer="true"\n                        data-hide-apply="true"\n                    >\n                        ' +
__e( s.title ) +
'\n                    </a>\n                </div>\n                <div class="suggestion-row__keymeta">\n                    <span class="suggestion-row__company">' +
__e( s.company_name ) +
'</span>\n                    <span class="suggestion-row__location">' +
__e( s.location_name ) +
'</span>\n                </div>\n            </div>\n\n            <div class="suggestion-row__details-container">\n                <div class="suggestion-row__details">\n                    <p>' +
((__t = ( s.description )) == null ? '' : __t) +
'</p>\n                </div>\n            </div>\n\n            <div class="suggestion-row__meta">\n                ';
 if (s.wage > 0) { ;
__p += '\n                    <div class="suggestion-row__meta-field">\n                        ' +
((__t = ( $.svgIcon('wallet') )) == null ? '' : __t) +
'\n                        <span class="suggestion-row__meta-value">$' +
__e( s.wage ) +
'/hour</span>\n                    </div>\n                ';
 } ;
__p += '\n                ';
 if (s.schedule_start) { ;
__p += '\n                    <div class="suggestion-row__meta-field">\n                        ' +
((__t = ( $.svgIcon('watch') )) == null ? '' : __t) +
'\n                        <span class="suggestion-row__meta-value">' +
__e( s.schedule_start ) +
'</span>\n                    </div>\n                ';
 } ;
__p += '\n                ';
 if (s.commute_times.driving || s.commute_times.transit) { ;
__p += '\n                    <div class="suggestion-row__commute-times">\n                        ';
 if (s.commute_times.driving) { ;
__p += '\n                            <div class="suggestion-row__commute-time">\n                                ' +
((__t = ( $.svgIcon('driving') )) == null ? '' : __t) +
'\n                                <span>';
 if (s.commute_times.driving >= 120) { ;
__p += '120+';
 } else { ;
__p +=
__e( s.commute_times.driving );
 } ;
__p += ' min</span>\n                            </div>\n                        ';
 } ;
__p += '\n                        ';
 if (s.commute_times.transit) { ;
__p += '\n                            <div class="suggestion-row__commute-time">\n                                ' +
((__t = ( $.svgIcon('transit') )) == null ? '' : __t) +
'\n                                <span>';
 if (s.commute_times.transit >= 120) { ;
__p += '120+';
 } else { ;
__p +=
__e( s.commute_times.transit );
 } ;
__p += ' min</span>\n                            </div>\n                        ';
 } ;
__p += '\n                    </div>\n                ';
 } ;
__p += '\n            </div>\n\n            ';
 if (s.autoMatch) { ;
__p += '\n                <div class="suggestion-row__auto-match-bar">\n                    <img src="' +
__e( $.staticURL('autoMatch.svg') ) +
'" class="suggestion-row__auto-match-icon" />\n                    You\'re pre-qualified to interview! <em>Why?</em>\n                </div>\n            ';
 } ;
__p += '\n\n            <div class="suggestions-row__link">\n                <a\n                    href="' +
__e( s.link ) +
'"\n                    class="js-job-detail js-job-data"\n                    data-id="position-detail-' +
__e( s.id ) +
'"\n                    data-url="' +
__e( s.link ) +
'"\n                    data-hide-footer="true"\n                    data-hide-apply="true"\n                >\n                    <span class="mobile-only">See Details</span>\n                    <span class="hidden-mobile">Details</span>\n                </a>\n            </div>\n        </li>\n    ';
 }) ;
__p += '\n</ul>\n\n<div class="suggestions__buttons detail-hidden" style="display: none">\n    <button class="btn btn-primary btn-large btn-special suggestions__submit">\n        Add <span class="hidden-mobile">selected</span> jobs\n        (<span class="suggestions__selected-count">' +
__e( count ) +
'</span>)\n    </button>\n</div>\n\n<div id="auto-match-modal" class="modal-small" style="display: none">\n    <h2>Why am I pre-qualified to interview?</h2>\n    <p>\n        Based on what we know about your skills and experience,\n        this company wants you to schedule an interview right away!\n    </p>\n    <a href="#" rel="modal:close" class="btn btn-primary btn-large">Got it</a>\n</div>\n';

}
return __p
}